"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.english = void 0;
var types_1 = require("../types");
exports.english = {
    code: types_1.LocaleCode.English,
    facebook: 'en_US',
    label: 'English',
    loadingText: 'Loading...',
    translations: {
        ar: 'Arabic',
        de: 'German',
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        id: 'Indonesian',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        lo: 'Lao',
        ms: 'Malay',
        pt: 'Portuguese',
        ru: 'Russian',
        th: 'Thai',
        tl: 'Filipino',
        tr: 'Turkish',
        vi: 'Vietnamese',
        'zh-CN': '‪Chinese (Simp.)',
        'zh-TW': '‪Chinese (Trad.)'
    }
};
